import styled from 'styled-components'

const WalidacjaErrorStyle = styled.div`
  width: 100%;
  min-height: 56px;
  display: grid;
  grid-template-rows: auto auto;
  background: #d9675d;
  margin-bottom: 4px;
  color: #fff;
  border-radius: 3px;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);

  p {
    margin: 0;
  }

  .icon {
    color: #000;
    opacity: 0.38;
    width: 28px;
    height: 28px;
    margin-top: 14px;
    justify-self: center;
  }

  .error {
    display: grid;
    border-left: 1px solid #843f3a;
    padding: 8px 0 12px 16px;
    grid-template-rows: 16px auto;
  }

  .enterBtns {
    display: flex;
    align-items: center;
    margin: auto;
    cursor: pointer;
    margin: 18px 12px 0 12px;
    height: 20px;
  }

  .showMore {
    cursor: pointer;
    margin: 18px 20px 0 0;
    width: 44px;
  }

  .enter {
    height: 20px;
  }

  .firstRow {
    display: grid;
    grid-row: 1/2;
    grid-template-columns: 56px 1fr auto auto;
  }

  .secondRow {
    grid-row: 2/3;
    display: grid;
    grid-template-columns: 56px 1fr;
  }

  .expandError {
    grid-column: 2/3;
    border-left: 1px solid #843f3a;
    padding: 0 16px 12px 16px;
  }

  .disabled {
    opacity: 0.38;
    cursor: default;
  }
`
export default WalidacjaErrorStyle
